import React from "react";

const Nav = () => {
  return (
    <ul className="menu-horizontal text-left">
      <li>
        <a href="#portfolio" data-scroll title="Examples of Client Work">
          Client Work
        </a>
      </li>
      <li>
        <a href="#brands" data-scroll title="Brands I've Worked With">
          Brands
        </a>
      </li>
      <li>
        <a href="#projects" data-scroll title="Personal Projects">
          Personal Projects
        </a>
      </li>
    </ul>
  );
};

export default Nav;
